<template>
  <div :class="['develop-course', 'section', {bgWarp: !isMobile}]">
    <div class="layout-content">
      <div class="content">
        <img class="content-img" :src="data.content.developImgMbile" v-if="isMobile">
        <div class="content-wrapper">
          <div v-for="item in data.content.list" :key="item.id">
            <div class="content-list">
              <div class="content-list-content">
                <img class="content-list-img" :src="item.idImg" />
                <a class="content-list-text" :href="item.link" target="_blank">{{item.text}}</a>
              </div>
              <img
                class="content-list-icon"
                :src="item.icon"
                v-if="!isMobile"
              >
            </div>
            <div class="content-line" />
          </div>

          <div class="see-more">
            <a class="content-list-text see-more-link" :href="data.content.moreLink" target="_blank">{{data.content.moreLabel}}</a>
            <img
              class="content-list-icon"
              :src="data.content.icon"
              v-if="!isMobile"
            >
          </div>
        </div>
        <img class="content-img" :src="data.content.developImg" v-if="!isMobile">
      </div>
    </div>
  </div>
</template>

<script>

import { mapState } from 'vuex'

import VueTypes from 'vue-types'

export default {
  name: 'develop-course',
  components: {
  },
  props: {
    data: VueTypes.object.def({})
  },
  data () {
    return {
    }
  },
  computed: {
    ...mapState(['isMobile', 'isEnLang']),

    title () {
      return this.isEnLang ? 'Development Programming' : '开发教程'
    },

    subText () {
      return this.isEnLang ? 'FINTECHATHON' : 'FINTECHATHON'
    }
  },

  created () {
  }
}
</script>

<style lang="scss" scoped>
.develop-course {
  padding-top: 120px;
  background: #F7F8FA;

  @include mobile {
    padding-top: 25px;
  }
}

.bgWarp {
  position: relative;
}

.content {
  display: flex; justify-content: center; align-items: center;

  @include mobile {
    flex-direction: column;
  }
}

.content-wrapper {
  width: 752px; height: 570px;
  padding: 45px 66px 70px  60px;
  background: #FFFFFF;

  @include mobile {
    width: 100%; height: auto;
    padding: 30px 24px 20px;
  }
}

.content-list {
  display: flex; justify-content: space-between; align-items: center;
}

.content-list-content {
  display: flex;

  &:hover {
    .content-list-text {
      font-size: 18px; font-weight: 500;
    }
  }

  @include mobile {
    display: flex;
  }
}

.content-list-img {
  display: inline-block;
  width: 22px; height: 22px;
  margin-right: 28px;

  @include mobile {
    width: 16px; height: 16px;
    margin: -1px 10px 0 0;
    transform: translateY(4px);
  }
}

.content-list-text {
  color: #000000;
  font-size: 18px; font-weight: 400;
  line-height: 25px;
  vertical-align: super;

  @include mobile {
    font-size: 14px;
  }
}

.see-more-link {
  margin-right: 20px;

  &:hover {
    font-weight: 500;
  }
}

.content-list-icon {
  width: 30px; height: 20px;
}

.content-line {
  width: 620px;
  margin: 28px 0 28px;
  border: 1px solid #000000;
  transform: scaleY(0.5);

  @include mobile {
    width: auto;
    margin: 14px 0 19px;
    border: 1px solid rgba(#000000, 0.1);
  }
}

.see-more {
  display: flex; justify-content: flex-end;
  padding-top: 10px;

  @include mobile {
    justify-content: center;
    width: fit-content; height: 36px;
    margin: 0 auto;
    padding: 0;
    text-align: center;
    border: 1px solid #000000;

    & .see-more-link {
      margin: 0 20px;
      line-height: 36px !important;
    }
  }
}

.content-list-more {
  color: #000000;
  font-size: 18px; font-weight: 400;
  line-height: 25px;
}

.content-img {
  width: 448px; height: 570px;

  @include mobile {
    width: 100%; height: 100%;
  }
}

</style>
